import React, { useState, useEffect } from "react";
import { getAccountAnalytics, getPortfolioHistory } from "../api/analyticsApi";
import { Line } from 'react-chartjs-2';
import { useNavigate } from "react-router-dom";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';


ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

export default function Analytics({ transactions, accountEquity = 0 }) {
  const navigate = useNavigate();
  const [hue, setHue] = useState(0)
  const [displayValue, setDisplayValue] = useState(accountEquity);
  const rainbowGlow = {
  animation: "rainbowGlow 4s linear infinite",
  borderWidth: 2,
  borderStyle: "solid",
  borderImageSlice: 1,
  borderImageSource:
    "linear-gradient(90deg, red, orange, yellow, green, cyan, blue, violet)"

    
};

  // Calculate summary stats
  const totalDeposits = transactions
    ? transactions.filter(t => t.type === 'Deposit').reduce((acc, t) => acc + t.amount, 0)
    : 0;
  const totalWithdrawals = transactions
    ? transactions.filter(t => t.type === 'Withdrawal').reduce((acc, t) => acc + t.amount, 0)
    : 0;
  const currentBalance = totalDeposits - totalWithdrawals;

   const [duration, setDuration] = useState("1M");

   const [percentChange, setPercentChange] = useState(0);
   const [coinCount, setCoinCount] = useState(0);
   const [chartValues, setChartValues] = useState([]);
   const [chartLabels, setChartLabels] = useState([]);

const filteredValues = chartValues;
const filteredLabels = chartLabels;


    const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false   // 👈 THIS removes both box and text
    },
    title: { display: false },
    tooltip: { mode: 'index', intersect: false },
  },
  scales: {
    x: { ticks: { color: '#fff' }, grid: { color: '#333' } },
    y: { ticks: { color: '#fff' }, grid: { color: '#333' }, beginAtZero: false },
  },
};

  <p
  style={{
    color: `hsl(${hue}, 100%, 60%)`,
    margin: 0,
    fontWeight: "bold",
    fontSize: "22px",
    letterSpacing: "1px",
    textShadow: `0 0 8px hsl(${hue}, 100%, 60%)`
  }}
>
  ${displayValue.toLocaleString()}
</p>

     
  
  
    useEffect(() => {
  const interval = setInterval(() => {
    setHue((prev) => (prev + 2) % 360);
  }, 40);

  return () => clearInterval(interval);
}, []);

  useEffect(() => {
    async function loadAccountEquity() {
      try {
        const token = localStorage.getItem("spectraToken") || "";
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/broker/account`, {
          headers: { "Authorization": `Bearer ${token}` }
        });
        const data = await res.json();
        setDisplayValue(data.equity ?? 0);
      } catch (err) {
        console.error("Failed to load account equity:", err);
      }
    }
    loadAccountEquity();
  }, []);

      useEffect(() => {

  async function loadAnalytics() {

    try {

      const token = localStorage.getItem("spectraToken") || "";
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/broker/history?period=${duration}`, {
        headers: { "Authorization": `Bearer ${token}` }
      });
      const history = await res.json();

      if (history && history.equity && history.timestamp) {
        const labels = history.timestamp.map(t =>
          new Date(t * 1000).toLocaleDateString()
        );
        setChartValues(history.equity);
        setChartLabels(labels);
      } else {
        setChartValues([]);
        setChartLabels([]);
      }

    } catch (err) {
      console.error("Analytics load error:", err);
    }

  }

  loadAnalytics();

}, [duration]);
       
   


const data = {
  labels: filteredLabels,
  datasets: [
    {
      label: "Portfolio Value",
      data: filteredValues,
      borderColor: `hsl(${hue}, 100%, 60%)`,
      backgroundColor: `hsla(${hue}, 100%, 60%, 0.2)`,
      borderWidth: 3,
      tension: 0.4,
      pointRadius: 4,
      pointBackgroundColor: `hsl(${hue}, 100%, 60%)`
      
    }
  ]
};

const showHigh = () => {
setDisplayValue(Math.max(...chartValues));
};

const showLow = () => {
setDisplayValue(Math.min(...chartValues));
};

  return (
    <div style={{ maxWidth: 1000, margin: '32px auto', background: '#1c1c1cff', padding: 24, borderRadius: 12, color: '#fff' }}>
       
       <style>
{`
@keyframes rainbowGlow {
  0% { filter: hue-rotate(0deg); }
  100% { filter: hue-rotate(360deg); }
}
`}
</style>

     
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 8
  }}
>
  <p
  style={{
    color: `hsl(${hue}, 100%, 60%)`,
    margin: 0,
    fontWeight: "bold",
    fontSize: "46px",
    letterSpacing: "1px",
    textShadow: `0 0 8px hsl(${hue}, 100%, 60%)`
  }}
>
  ${displayValue.toLocaleString()}
</p>


           
           <button
  onClick={() => navigate("/periodic")}
  style={{
    background: "transparent",
    border: "none",
    cursor: "pointer",
    padding: 0
  }}
>
  <img
    src="/spectra-logo.jpg"
    alt="Go to Periodic"
    style={{
      width: 110,
      height: 90,
      objectFit: "contain",
      transition: "transform 0.2s ease"
    }}
    onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
    onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
  />
</button>
</div>
     
    {/* Summary Cards */}
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    marginTop: 24,
    gap: 16
  }}
>

 
  <div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 10
  }}
>

  {/* Current Investment Placeholder */}
  <div
    style={{
      minWidth: 80,
      padding: "6px 12px",
      background: "#1c1c1c",
      borderRadius: 6,
      color: "#777",
      fontSize: 14,
      textAlign: "center"
    }}
  >
    ...
  </div>

  {/* Total Coins Purchased Placeholder */}
  <div
    style={{
      minWidth: 80,
      padding: "6px 12px",
      background: "#1c1c1c",
      borderRadius: 6,
      color: "#777",
      fontSize: 14,
      textAlign: "center"
    }}
  >
    ...
  </div>

  {/* High */}
  <button
      onClick={showHigh}
    style={{
      padding: "6px 14px",
      borderRadius: 6,
      background: "#111",
      color: "#fff",
      fontSize: 12,
      cursor: "pointer",
      border: "2px solid",
      borderImage:
        "linear-gradient(90deg, red, orange, yellow, green, cyan, blue, violet) 1",
      animation: "rainbowGlow 4s linear infinite"
    }}
  >
    High
  </button>

  {/* Low */}
  <button
       onClick={showLow}
    style={{
      padding: "6px 14px",
      borderRadius: 6,
      background: "#111",
      color: "#fff",
      fontSize: 12,
      cursor: "pointer",
      border: "2px solid",
      borderImage:
        "linear-gradient(90deg, red, orange, yellow, green, cyan, blue, violet) 1",
      animation: "rainbowGlow 4s linear infinite"
    }}
  >
    Low
  </button>

</div>


  </div> {/* end Summary Card */}

       {/* Chart */}
<div
  style={{
    marginTop: 32,
    background: "#171616d4",
    padding: 23,
    borderRadius: 5,
    position: "relative"
  }}
>

  <div
    style={{
      position: "absolute",
      top: 6,
      right: 5,
      zIndex: 6
    }}
  >
    <select
  value={duration}
  onChange={(e) => setDuration(e.target.value)}
  style={{
    background: "#111",
    color: "#fff",
    border: "1px solid #333",
    borderRadius: 6,
    padding: "4px 8px",
    fontSize: 8,
    cursor: "pointer",
    outline: "none"
  }}
>

    
    
      <option value="1D">1D</option>
      <option value="1M">1M</option>
      <option value="3M">3M</option>
      <option value="6M">6M</option>
      <option value="1Y">1Y</option>
      <option value="All">All</option>
    </select>
  </div>

  <Line data={data} options={options} />

</div>

</div>
  );
}
